<script>
import Layout from '@layouts/legacy-panel.vue'
import { mapActions, mapGetters } from 'vuex'
import UserManagementSkeleton from '@components/candidate/user-management-skeleton.vue'
import UserManagementContainer from '@components/candidate/user-management-container.vue'
// eslint-disable-next-line no-unused-vars
import CandidateR2WUserDetailsViewModel from '@/models/candidate/candidateR2WUserDetailsViewModel'

export default {
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [
        {
          name: 'description',
          content: 'The Candidate User Management panel.',
        },
      ],
    }
  },
  components: { Layout, UserManagementContainer, UserManagementSkeleton },
  data: () => {
    return {
      /**
       * @type {number}
       */
      candidateId: null,
      /**
       * @type {CandidateR2WUserDetailsViewModel}
       */
      r2WUserDetails: null,
    }
  },
  computed: {
    ...mapGetters({
      isLoadingCandidateUserDetails: 'candidate/isLoadingCandidateUserDetails',
    }),
  },
  async created() {
    this.candidateId = Number(this.$route.params?.candidateId)

    const response = await this.getUserDetails(this.candidateId)

    if (response.isSuccess) this.r2WUserDetails = response.data
  },
  methods: {
    ...mapActions({
      getUserDetails: 'candidate/getUserDetails',
    }),
    handleLoginCreated() {
      this.r2WUserDetails.hasLinkToR2WUser = true
      this.r2WUserDetails.userEmail = this.r2WUserDetails.candidateEmail
    },
    handleLoginEmailSynchronised() {
      this.r2WUserDetails.hasEmailMismatch = false
      this.r2WUserDetails.userEmail = this.r2WUserDetails.candidateEmail
    },
    handleLoginRemoved() {
      this.r2WUserDetails.hasLinkToR2WUser = false
      this.r2WUserDetails.hasEmailMismatch = false
      this.r2WUserDetails.userEmail = ''
    },
  },
}
</script>

<template>
  <Layout>
    <UserManagementSkeleton v-if="isLoadingCandidateUserDetails" />
    <UserManagementContainer
      v-else-if="r2WUserDetails"
      :user-details="r2WUserDetails"
      :candidate-id="candidateId"
      @login-created="handleLoginCreated"
      @login-email-synchronised="handleLoginEmailSynchronised"
      @login-removed="handleLoginRemoved"
    />
  </Layout>
</template>
